var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntDesignForwardOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 30,
    viewBox: "0 0 62 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9996 14.5897L32.5984 7.32118C31.9506 7.05165 31 7.29481 31 7.73134V22.2714C31 22.7079 31.9506 22.9511 32.5984 22.6815L49.9996 15.41C50.5021 15.1991 50.5021 14.8007 49.9996 14.5897ZM30.6246 14.5897L13.2234 7.32118C12.5756 7.05165 11.625 7.29481 11.625 7.73134V22.2714C11.625 22.7079 12.5756 22.9511 13.2234 22.6815L30.6246 15.41C30.8729 15.3046 31 15.1522 31 14.9999C31 14.8475 30.8729 14.6952 30.6246 14.5897Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignForwardOutlined);
export default __webpack_public_path__ + "static/media/ant-design_forward-outlined.ba98c260a6d4b4eb6ecf0eff9651eb48.svg";
export { ForwardRef as ReactComponent };